import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertCircle } from "lucide-react";

interface ProfileCompletionModalProps {
  isOpen: boolean;
  onClose: () => void;
  missingFields: { field: string; label: string }[];
}

export const ProfileCompletionModal = ({ 
  isOpen, 
  onClose, 
  missingFields 
}: ProfileCompletionModalProps) => {
  const navigate = useNavigate();

  const handleCompleteProfile = () => {
    onClose();
    navigate('/settings');
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-orange-100 dark:bg-orange-900/20">
              <AlertCircle className="h-5 w-5 text-orange-600 dark:text-orange-400" />
            </div>
            <AlertDialogTitle className="text-xl">Complete Your Profile</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base">
            To schedule a pickup and ship your boxes, we need the following information:
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="py-4">
          <ul className="space-y-2">
            {missingFields.map((field) => (
              <li key={field.field} className="flex items-center gap-2 text-sm">
                <div className="h-1.5 w-1.5 rounded-full bg-orange-500" />
                <span className="text-muted-foreground">{field.label}</span>
              </li>
            ))}
          </ul>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleCompleteProfile}>
            Complete Profile Now
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
